<template>
  <div class="thermo-popup">
    <!-- Header -->
    <div class="popup-header">
      <span class="title">{{ $t('map.track_sensor_data') }}</span>

    </div>

    <!-- Gauges -->
    <div class="gauge-container">
      <!-- Temperature -->
      <div class="gauge-row">
        <div class="thermometer">
          <div class="thermo-tube">
            <div class="thermo-fill" :style="{ height: tempHeight + '%' }"></div>
          </div>
          <div class="thermo-bulb"></div>
        </div>
        <div class="gauge-info">
          <div class="gauge-label">{{ $t('map.temperature') }}</div>
          <div class="gauge-value" style="color: #ff4d4d">
            {{ formatTempValue(temperature,getUnit('temp')) }}<span class="unit">{{getUnit('temp')}}</span>
          </div>
        </div>
      </div>

      <!-- Humidity -->
      <div class="gauge-row">
        <div class="hygrometer">
          <div class="hygro-tube">
            <div class="hygro-fill" :style="{ height: humHeight + '%' }"></div>
          </div>
          <div class="hygro-bulb"></div>
        </div>
        <div class="gauge-info">
          <div class="gauge-label">{{ $t('map.humidity') }}</div>
          <div class="gauge-value" style="color: #4dabff">
            {{ humidity }}<span class="unit">%RH</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="popup-footer">
      <span>{{ $t('map.track_collection_time') }}: {{ timeStr }}</span>
      <span>{{ $t('map.track_speed') }}: {{ speed.toFixed(1) }} mph</span>
    </div>
  </div>
</template>

<script>
import { TempUtils } from '@/utils/TempUtil'

export default {
  name: 'ThermohygrometerPopup',
  props: {
    pointIndex: { type: Number, required: true },
    temperature: { type: [Number, String], required: true },
    humidity: { type: [Number, String], required: true },
    speed: { type: Number, required: true },
    timeStr: { type: String, required: true }
  },
  computed: {
    tempHeight() {
      const t = parseFloat(this.temperature)
      // 温度范围 -20°C 到 50°C 映射到 0-100%
      return Math.min(Math.max(((t + 20) / 70) * 100, 0), 100)
    },
    humHeight() {
      return Math.min(Math.max(parseFloat(this.humidity), 0), 100)
    }
  },
  methods:{
    // 获取单位
    getUnit (code) {
      const { unit } = this.$store.state
      if (unit && unit[code]) {
        return unit[code].name || ''
      }
      return code === 'temp' ? '°C' : '%RH'
    },

    // 格式化温度值
    formatTempValue (val, code) {
      if (val === null || val === undefined || val === '') return '--'
      const numVal = Number(val)
      if (isNaN(numVal)) return '--'

      const result = TempUtils.convertToCelsius(numVal, code)
      return `${result}`
    },
  }
}
</script>

<style lang="scss" scoped>
.thermo-popup {
  width: 260px;
  font-family: inherit;

  .popup-header {
    background: #4264fb;
    color: #fff;
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 14px;
      font-weight: 600;
    }

    .index {
      font-size: 12px;
      opacity: 0.85;
      background: rgba(255, 255, 255, 0.2);
      padding: 2px 8px;
      border-radius: 10px;
    }
  }

  .gauge-container {
    background: #fff;
    padding: 16px;
  }

  .gauge-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .gauge-info {
    flex: 1;
  }

  .gauge-label {
    font-size: 12px;
    color: #8a90a0;
    margin-bottom: 4px;
  }

  .gauge-value {
    font-size: 24px;
    font-weight: 700;
    display: flex;
    align-items: baseline;

    .unit {
      font-size: 12px;
      font-weight: 400;
      color: #4a5160;
      margin-left: 4px;
    }
  }

  // ---- Thermometer ----
  .thermometer {
    width: 16px;
    height: 60px;
    position: relative;
    margin-right: 15px;
  }

  .thermo-tube {
    width: 6px;
    height: 45px;
    background: #f0f0f0;
    border-radius: 3px;
    position: absolute;
    left: 5px;
    top: 0;
    overflow: hidden;
  }

  .thermo-fill {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(to top, #ff4d4d, #ff9966);
    transition: height 0.5s ease;
  }

  .thermo-bulb {
    width: 14px;
    height: 14px;
    background: #ff4d4d;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    left: 1px;
    box-shadow: inset -2px -2px 4px rgba(0, 0, 0, 0.2);
  }

  // ---- Hygrometer ----
  .hygrometer {
    width: 16px;
    height: 60px;
    position: relative;
    margin-right: 15px;
  }

  .hygro-tube {
    width: 6px;
    height: 45px;
    background: #f0f0f0;
    border-radius: 3px;
    position: absolute;
    left: 5px;
    top: 0;
    overflow: hidden;
  }

  .hygro-fill {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(to top, #4dabff, #80c7ff);
    transition: height 0.5s ease;
  }

  .hygro-bulb {
    width: 14px;
    height: 14px;
    background: #4dabff;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    left: 1px;
    box-shadow: inset -2px -2px 4px rgba(0, 0, 0, 0.2);
  }

  .popup-footer {
    background: #f9fafc;
    padding: 10px 16px;
    border-top: 1px solid #ebeef5;
    font-size: 11px;
    color: #888;
    display: flex;
    justify-content: space-between;
  }
}
</style>
